export const getWalkInDateRange = (walkInHoursOfDay, localDate) => {
    const checkTimeOpen = (time: string) => (time?.trim() !== "" ? time : "00:00");
    const checkTimeClose = (time: string) =>
        time?.trim() !== "" && time?.trim() !== "00:00" ? time : "23:59";

    const openingTime = checkTimeOpen(walkInHoursOfDay?.open);
    const [openHour, openMin] = (openingTime ?? "").split(":");
    const openDate = new Date(localDate?.toISOString());
    openDate.setHours(Number(openHour));
    openDate.setMinutes(Number(openMin));

    const closingTime = checkTimeClose(walkInHoursOfDay?.close);
    const [closeHour, closeMin] = (closingTime ?? "").split(":");
    const closeDate = new Date(localDate?.toISOString());
    closeDate.setHours(Number(closeHour));
    closeDate.setMinutes(Number(closeMin));

    return [openDate, closeDate];
};
